/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://ine23khrhnbybivaus6gixlfci.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-caacdwjrtnfalgrk4nt7qf5wtq",
    "aws_cognito_identity_pool_id": "us-east-1:1baca9ae-c339-4fb8-a2ea-bab40e9ccbb6",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_uRznIAeDB",
    "aws_user_pools_web_client_id": "24gkbbt1karbp91g06tqh77k2k",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "vtdlpdev-env-assets1ccb6-vtdlppprd",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
